import { IComponentChildrenProps } from '@src/models/props';
import React, { createContext, FC, useContext, useMemo, useState } from 'react';

interface IModalContext {
  /** @deprecated dont`t use */
  _getParentRef: () => HTMLElement | null;
  /** Ссылка на backdrop родительской модалки */
  parentRef: HTMLElement | null;
  /** Дерево родителей */
  parentTree: HTMLElement[];
  /** Сетим реф для потомков */
  setBackdropRef: (element: HTMLElement | null) => void;
}

interface IModalProviderProps extends IComponentChildrenProps {}

export const ModalContext = createContext<IModalContext>({
  _getParentRef: () => null,
  parentRef: null,
  parentTree: [],
  setBackdropRef: () => {},
});

export const ModalProvider: FC<IModalProviderProps> = ({ children }) => {
  const { _getParentRef, parentTree } = useContext(ModalContext);
  const [backdropRef, setBackdropRef] = useState<HTMLElement | null>(null);

  const value = useMemo<IModalContext>(() => {
    const parentRef = _getParentRef();

    return {
      parentRef,
      parentTree: parentRef ? [parentRef, ...parentTree] : [],
      _getParentRef: () => backdropRef,
      setBackdropRef,
    };
  }, [_getParentRef, setBackdropRef, backdropRef, parentTree]);

  return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>;
};
